import { createApi } from "@reduxjs/toolkit/query/react";
import { authBaseQuery } from "../../services/baseQuery";


export const authApi = createApi({
  reducerPath: "authApi",
   baseQuery:authBaseQuery,
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (formData) => ({
        url: "anpr-fleet/authentication/mobile/login/create-token/",
        method: "POST",
        body: formData,
      }),
    }),
  }),
});

export const { useLoginMutation } = authApi;